/**
 * The campaign's tag vocabulary (92:2): one panel of every category, the locked alignment
 * first, each with its icon, values, active toggle, rename and delete, and a 'Nova tag' create
 * affordance. The seeded defaults are the organisation's like any category it created.
 */
import { PlusIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { Page, PageHeader } from '../../../chrome/page';
import { EmptyState, QueryStates } from '../../../chrome/state';
import { Button } from '../../../ui/button';
import { useCan } from '../../session/orgContext';
import { useTagVocabulary } from './api/queries';
import { CategoryPanel } from './CategoryPanel';
import { tgp, tgt } from './messages';
import { NewCategory } from './NewCategory';

export function Tags(props: { campaignId: string }): ReactNode {
  const { campaignId } = props;
  const canWrite = useCan('control_plane.write');
  const vocabulary = useTagVocabulary(campaignId);

  return (
    <Page>
      <PageHeader
        title={tgt('heading')}
        actions={
          <NewCategory
            campaignId={campaignId}
            trigger={
              <Button type="button">
                <PlusIcon aria-hidden className="size-4" />
                {tgt('create.trigger')}
              </Button>
            }
          />
        }
      />
      <QueryStates
        query={vocabulary}
        isEmpty={(data) => data.length === 0}
        empty={<EmptyState title={tgt('empty.title')} description={tgt('empty.body')} />}
      >
        {(categories) => (
          <CategoryPanel
            title={tgt('panel.title')}
            subtitle={tgp('panel.subtitle.other', categories.length, {
              active: categories.filter((category) => category.active).length,
              total: categories.length,
            })}
            categories={categories}
            campaignId={campaignId}
            canWrite={canWrite}
            footer={
              canWrite ? (
                <NewCategory
                  campaignId={campaignId}
                  trigger={
                    <Button type="button" variant="ghost" size="sm" className="mx-auto flex">
                      <PlusIcon aria-hidden className="size-4" />
                      {tgt('create.trigger')}
                    </Button>
                  }
                />
              ) : undefined
            }
          />
        )}
      </QueryStates>
    </Page>
  );
}
